import script from "./WCToastModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCToastModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCToastModern.vue?vue&type=style&index=0&id=7ceeb8fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ceeb8fb"]])

export default __exports__